module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gadgetTasks"
  }, [(_vm.isLoadingDataTaskGadget) ? _c('div', {
    staticClass: "loadingData"
  }) : _c('vue-tabs', {
    attrs: {
      "id": "tab-navigation",
      "centered": "centered"
    }
  }, [_c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-tarefas-pendentes-dashboard",
      "title": _vm.$t("estatistica.tarefa.labels.naoConcluida"),
      "icon": "fa fa-clock-o fa-task-gadget"
    }
  }, [(_vm.hasData.tarefasPendentes) ? _c('task-gadget-tab-content', {
    attrs: {
      "data": _vm.data,
      "quantidadeMovFin": _vm.data.quantidadePendenteMovFin,
      "quantidadeMovBan": _vm.data.quantidadePendenteMovBan,
      "totalQuantidade": _vm.data.totalQuantidadePendente,
      "isPendentTab": true
    }
  }) : _vm._e(), _c('div', {
    staticClass: "clear"
  })], 1), _c('v-tab', {
    staticClass: "tab",
    attrs: {
      "id": "tab-tarefas-conciliadas-dashboard",
      "title": _vm.$t("estatistica.tarefa.labels.concluida"),
      "icon": "fa fa-check fa-task-gadget"
    }
  }, [(_vm.hasData.tarefasConciliadas) ? _c('task-gadget-tab-content', {
    attrs: {
      "data": _vm.data,
      "quantidadeMovFin": _vm.data.quantidadeConcluidaMovFin,
      "quantidadeMovBan": _vm.data.quantidadeConcluidaMovBan,
      "totalQuantidade": _vm.data.totalQuantidadeConcluida,
      "isPendentTab": false
    }
  }) : _vm._e(), _c('div', {
    staticClass: "clear"
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30421256", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30421256"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/gadget/taskGadget.pug
// module id = 1393
// module chunks = 0